import React from "react";
import {
  Box,
  Flex,
  Text,
  Heading,
  Divider,
  Icon,
  HStack,
} from "@chakra-ui/react";
import Button from "@components/common/Button";
import type {
  IOportunityComponents,
  ValuesFormikCreateMyOportunityComponent,
} from "src/@types/Sales";
import { useFormik } from "formik";
import { isEmail } from "@helpers/emailCheck";
import { LoginContext } from "@context/loginContext";
import enterprisesServiceInstance from "@services/Enterprises/enterprisesService";
import Alert from "@components/common/Alert";
import salesService from "@services/Sales/SalesService";
import Spinner from "@components/common/Spinner";
import SectionMyOportunityComponent from "../../components/SectionMyOportunity/SectionMyOportunityComponent";
import SectionProductInterestComponent from "../../components/SectionMyOportunity/SectionProductInterestComponent";
import { phoneMask } from "@helpers/format";
import { UsuallyContext } from "@context/usuallyContex";
import { AiOutlineInfoCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { OportunityContext } from "@context/oportunityContex";
import ToastNotify from "@components/Sales/ToastNotify";
import { getDateOrNull } from "../../components/AccordionCreditRatingComponent";
import oportunityServiceInstance from "@services/Oportunity/OportunityService";
import { theme } from "src/styles/theme";
import { useNavigate } from "react-router-dom";
import { cookieKeys, getCookie } from "@helpers/cookies";

const CreateMyOportunityComponent = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/oportunidades");
  };
  const handleNavigate = () => {
    navigate("/oportunidades");
    // navigate("/oportunidades/minhas-oportunidades");
  };

  return (
    <CreateMyOportunityComponentOriginal
      onBack={handleBack}
      navigation={handleNavigate}
    />
  );
};

const CreateMyOportunityComponentOriginal = ({
  onBack,
  navigation,
}: IOportunityComponents) => {
  const regionalUser: any = localStorage.getItem("@regional");
  const idCorretor = getCookie(cookieKeys.idCorretor) || "";
  const user: any = localStorage.getItem("@user");
  const tipoDeUsuario: any = localStorage.getItem("@tipoDeUsuario");

  const { signOut, setPageSidebar } = React.useContext(LoginContext);
  const {
    setSuccessCreateOportunity,
    setNameCreateOportunity,
    accountIdSalesforce,
  } = React.useContext(UsuallyContext);
  const { origemConta, setAccessCreateOp, setIndexTabDetails } =
    React.useContext(OportunityContext);
  const [isUnauthorized, setIsUnauthorized] = React.useState(false);
  const [require, setRequire] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loadingOportunity, setLoadingOportunity] = React.useState(false);
  const [loadingEnterprises, setLoadingEnterprises] = React.useState(false);
  const [dataEnterprises, setDataEnterprises] = React.useState([]);
  const [loadingCampaign, setLoadingCampaign] = React.useState(false);
  const [dataCampaign, setDataCampaign] = React.useState([]);
  const [idEnterprises, setIdEnterprises] = React.useState("");
  const [idCampaign, setIdCampaign] = React.useState("");
  const [ageGroup, setAgeGroup] = React.useState("");
  const [nacionality, setNacionality] = React.useState("");
  const [sex, setSex] = React.useState("");
  const [error, setError] = React.useState({
    email: false,
    telefone: false,
  });
  const [errorOportunity, setErrorOportunity] = React.useState("");
  const [showErrorOportunity, setShowErrorOportunity] = React.useState(false);
  const [campaign, setCampaign] = React.useState("");
  const [selectCampaign, setSelectCampaign] = React.useState("");
  const [mainEnterprises, setMainEnterprises] = React.useState("");
  const [selectMainEnterprises, setSelectMainEnterprises] = React.useState("");
  const [isOriginAccount, setIsOriginAccount] = React.useState(false);
  const [data, setData] = React.useState<any>([]);

  const [broker, setBroker] = React.useState("");
  const [selectBroker, setSelectBroker] = React.useState("");
  const [idBroker, setIdBroker] = React.useState("");
  const [dataBroker, setDataBroker] = React.useState<any>([]);
  const [loadingBroker, setLoadingBroker] = React.useState(false);
  const [regional, setRegional] = React.useState("");
  const [commercialRegional, setCommercialRegional] = React.useState("");

  const initialValues = {
    nameAccount: data?.nome || "",
    mainPhone: data?.telefone || "",
    mainEmail: data?.email || "",
    complementaryPhone: data?.telefoneComplementar || "",
    complementaryEmail: data?.emailComplementar || "",
    comments: "",
    dateBday: data?.dataNascimento || "",
  };

  const formik: any = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values) => handleSubmitFormik(values),
  });

  const handleSubmitFormik = async (
    value: ValuesFormikCreateMyOportunityComponent
  ) => {
    setLoading(true);
    setShowErrorOportunity(false);
    setSuccessCreateOportunity(false);

    const body = {
      regional: regional,
      accountIdSalesforce,
      idCorretorSalesforce:
        tipoDeUsuario === "Gerente" || tipoDeUsuario === "Coordenador"
          ? idBroker
          : idCorretor,
      fase: null,
      origemConta,
      nomeDaConta: value?.nameAccount,
      nomeCorretor:
        tipoDeUsuario === "Gerente" || tipoDeUsuario === "Coordenador"
          ? broker
          : user,
      telefonePrincipal: phoneMask(value?.mainPhone),
      dataNascimento: value?.dateBday,
      nacionalidade: nacionality,
      emailPrincipal: value?.mainEmail,
      emailComplementar: value?.complementaryEmail,
      faixaEtaria: ageGroup,
      sexo: sex,
      empreendimentoDeInteressePrincipal: idEnterprises,
      campanha: idCampaign,
      telefoneComplementar: value?.complementaryPhone,
      regionalComercial: commercialRegional,
    };

    const bodyNotRegionl = {
      regional: regional,
      accountIdSalesforce,
      idCorretorSalesforce:
        tipoDeUsuario === "Gerente" || tipoDeUsuario === "Coordenador"
          ? idBroker
          : idCorretor,
      fase: null,
      origemConta,
      nomeDaConta: value?.nameAccount,
      nomeCorretor:
        tipoDeUsuario === "Gerente" || tipoDeUsuario === "Coordenador"
          ? broker
          : user,
      telefonePrincipal: phoneMask(value?.mainPhone),
      dataNascimento: value?.dateBday,
      nacionalidade: nacionality,
      emailPrincipal: value?.mainEmail,
      emailComplementar: value?.complementaryEmail,
      faixaEtaria: ageGroup,
      sexo: sex,
      empreendimentoDeInteressePrincipal: idEnterprises,
      campanha: idCampaign,
      telefoneComplementar: value?.complementaryPhone,
    };

    try {
      const response = await salesService.createOportunity(
        regional === "SP" ? body : bodyNotRegionl
      );

      if (
        response?.status === 400 &&
        response?.data
          ?.toLowerCase()
          ?.includes("fase superior a visita realizada")
      ) {
        setErrorOportunity(
          "Não é possível criar a oportunidade pois já existe outra com fase superior a Visita realizada."
        );
        setShowErrorOportunity(true);
        setLoading(false);
        return;
      }
      if (
        response?.status === 400 &&
        response?.data?.toLowerCase()?.includes("oportunidade aberta")
      ) {
        setErrorOportunity(response?.data);
        setShowErrorOportunity(true);
        setLoading(false);
        return;
      }
      if (
        response?.status === 400 &&
        response?.data?.toLowerCase()?.includes("parâmetros informados")
      ) {
        setErrorOportunity(
          "Não é possível criar a oportunidade com os parâmetros informados."
        );
        setShowErrorOportunity(true);
        setLoading(false);
        return;
      }

      if (
        response?.status === 400 &&
        (!response?.data
          ?.toLowerCase()
          ?.includes("fase superior a visita realizada") ||
          !response?.data?.toLowerCase()?.includes("parâmetros informados"))
      ) {
        setError((prevState) => ({
          ...prevState,
          email: response?.data.emailJaUtilizado,
          telefone: response?.data.telefoneJaUtilizado,
        }));

        setLoading(false);
        return;
      }

      if (response?.status === 401) {
        setLoading(false);
        setIsUnauthorized(true);
        return;
      }

      setAccessCreateOp({
        oportunidadeId: response?.oportunidadeId,
        oportunityIdSalesforce: response?.opportunityIdSalesforce,
        nomeDaConta: response?.nomeDaConta,
      });
      setNameCreateOportunity(value?.nameAccount);
      setSuccessCreateOportunity(true);
      setIndexTabDetails(0);
      // setPageSidebar("Minhas oportunidades");
      // localStorage.setItem("@option", "Minhas oportunidades");
      navigation();
      setLoading(false);
    } catch (error) {
      console.log("ErrorFormik", error);
      setLoading(false);
    }
  };

  const handleGetEnterprises = async () => {
    setLoadingEnterprises(true);

    try {
      const response = await enterprisesServiceInstance.getEnterprises({
        regional: regionalUser,
      });

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingEnterprises(false);
        setDataEnterprises([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingEnterprises(false);
        setIsUnauthorized(true);
        setDataEnterprises([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataEnterprises(dataArray);
      setLoadingEnterprises(false);
    } catch (error) {
      setLoadingEnterprises(false);
      console.log("errorHandleGetEnterprises", error);
    }
  };

  const handleGetCampaign = async () => {
    setLoadingCampaign(true);

    try {
      const response = await salesService.getCampaign();

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingCampaign(false);
        setDataCampaign([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingCampaign(false);
        setIsUnauthorized(true);
        setDataCampaign([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataCampaign(dataArray);
      setLoadingCampaign(false);
    } catch (error) {
      setLoadingCampaign(false);
      console.log("errorHandleGetEnterprises", error);
    }
  };

  const handleGetBroker = async () => {
    setLoadingBroker(true);

    try {
      const response = await oportunityServiceInstance.getUserByEquip();

      if (response.status >= 400 && response?.status !== 401) {
        setLoadingBroker(false);
        setDataBroker([]);
        console.log("status 400", response);
        return;
      }
      if (response.status === 401) {
        setLoadingBroker(false);
        setIsUnauthorized(true);
        setDataBroker([]);
        return;
      }

      const dataArray: any = Object.values(response);

      setDataBroker(dataArray);
      setLoadingBroker(false);
    } catch (error) {
      setLoadingBroker(false);
      console.log("errorHandleGetBroker", error);
    }
  };

  const nameParts = formik.getFieldProps("nameAccount").value?.split(" ");
  const filteredNameParts = nameParts?.filter(
    (part: string) => part?.trim() !== ""
  );

  React.useEffect(() => {
    const handleGetAccountById = async () => {
      setLoadingOportunity(true);
      try {
        const response = await salesService.getAccountById({
          accountIdSalesforce,
        });

        if (response?.status === 400) {
          setError((prevState) => ({
            ...prevState,
            email: response?.data.emailJaUtilizado,
            telefone: response?.data.telefoneJaUtilizado,
          }));

          setLoadingOportunity(false);
          return;
        }
        if (response?.status === 401) {
          setLoadingOportunity(false);
          setIsUnauthorized(true);
          return;
        }

        setData(response);
        setRegional(response?.regional);
        setCommercialRegional(response?.regionalComercial);
        setIsOriginAccount(response?.origemConta === "Digital");
        setNacionality(response?.nacionalidade || "");
        setAgeGroup(response?.faixaEtaria || "");
        setSex(response?.sexo || "");

        if (response?.dataNascimento) {
          formik.setValue("dateBday", getDateOrNull(response?.dataNascimento));
        }
        setLoadingOportunity(false);
      } catch (error) {
        console.log("ErrorHandleGetAccountById", error);
        setLoadingOportunity(false);
      }
    };

    handleGetAccountById();
  }, [accountIdSalesforce]);

  React.useEffect(() => {
    if (tipoDeUsuario === "Gerente" || tipoDeUsuario === "Coordenador") {
      const isRequirement =
        !broker ||
        !formik.getFieldProps("nameAccount").value ||
        (filteredNameParts?.length ?? 0) < 2 ||
        !formik.getFieldProps("mainEmail").value ||
        (!isEmail(formik.getFieldProps("mainEmail").value) &&
          formik.getFieldProps("mainEmail").value) ||
        (phoneMask(formik.getFieldProps("complementaryPhone").value)?.length <
          15 &&
          formik.getFieldProps("complementaryPhone").value) ||
        (!isEmail(formik.getFieldProps("complementaryEmail").value) &&
          formik.getFieldProps("complementaryEmail").value) ||
        (regional === "SP" && !commercialRegional);

      setRequire(isRequirement);
    } else {
      const isRequirement =
        !formik.getFieldProps("nameAccount").value ||
        (filteredNameParts?.length ?? 0) < 2 ||
        !formik.getFieldProps("mainEmail").value ||
        (!isEmail(formik.getFieldProps("mainEmail").value) &&
          formik.getFieldProps("mainEmail").value) ||
        (phoneMask(formik.getFieldProps("complementaryPhone").value)?.length <
          15 &&
          formik.getFieldProps("complementaryPhone").value) ||
        (!isEmail(formik.getFieldProps("complementaryEmail").value) &&
          formik.getFieldProps("complementaryEmail").value) ||
        (regional === "SP" && !commercialRegional);

      setRequire(isRequirement);
    }
  }, [
    filteredNameParts,
    tipoDeUsuario,
    broker,
    formik,
    regional,
    commercialRegional,
  ]);

  return (
    <>
      <Alert
        onOpen={isUnauthorized}
        title="Sessão expirada"
        titleButton={"Fazer login novamente"}
        description={
          "Sua sessão expirou, faça login novamente para ter acesso."
        }
        onClick={() => {
          signOut();
        }}
      />
      <ToastNotify
        height="210px"
        onOpen={showErrorOportunity}
        title={"Não foi possível criar uma oportunidade."}
        message={errorOportunity}
        titleButton={"VOLTAR"}
        onClick={() => setShowErrorOportunity(false)}
      />

      <Flex w="100%" alignItems="center" mb="6px" mt="16px">
        <Flex alignItems="center" gap="10px">
          <Heading as="h1" fontSize="24px" fontWeight="medium">
            Criar nova oportunidade
          </Heading>
        </Flex>
      </Flex>

      <Box
        w="100%"
        bg="white"
        borderRadius="8px"
        boxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)"
        p="10px"
        mb="20px"
        mt="12px"
      >
        <Flex justifyContent="flex-end" alignItems="center">
          <Icon
            aria-label="Close"
            onClick={onBack}
            display={"flex"}
            alignItems="center"
            justifyContent="center"
            fontSize={"26px"}
            w={"20px"}
            h={"auto"}
            cursor={"pointer"}
          >
            <AiOutlineCloseCircle />
          </Icon>
        </Flex>

        {loadingOportunity ? (
          <Flex justifyContent="center" alignItems="center" h="200px" w="100%">
            <Spinner />
          </Flex>
        ) : (
          <>
            <Box w="100%" mb="20px">
              <SectionMyOportunityComponent
                formik={formik}
                regional={regional}
                isOriginAccount={isOriginAccount}
                error={error}
                setError={setError}
                ageGroup={ageGroup}
                setAgeGroup={setAgeGroup}
                nacionality={nacionality}
                setNacionality={setNacionality}
                sex={sex}
                setSex={setSex}
                broker={broker}
                setBroker={setBroker}
                selectBroker={selectBroker}
                setSelectBroker={setSelectBroker}
                loadingBroker={loadingBroker}
                dataBroker={dataBroker}
                setIdBroker={setIdBroker}
                getBroker={handleGetBroker}
                commercialRegional={commercialRegional}
                setCommercialRegional={setCommercialRegional}
              />
            </Box>

            <Box w="100%" mb="20px">
              <SectionProductInterestComponent
                setIdCampaign={setIdCampaign}
                dataCampaign={dataCampaign}
                getCampaign={handleGetCampaign}
                campaign={campaign}
                setCampaign={setCampaign}
                selectCampaign={selectCampaign}
                setSelectCampaign={setSelectCampaign}
                loadingCampaign={loadingCampaign}
                dataEnterprises={dataEnterprises}
                getEnterprises={handleGetEnterprises}
                selectMainEnterprises={selectMainEnterprises}
                setSelectMainEnterprises={setSelectMainEnterprises}
                mainEnterprises={mainEnterprises}
                setIdEnterprise={setIdEnterprises}
                setMainEnterprises={setMainEnterprises}
                loadingEnterprises={loadingEnterprises}
              />
            </Box>

            <Divider my={4} />

            <Flex
              flexDir={{ base: "column", sm: "column", md: "row" }}
              justifyContent="space-between"
              alignItems="center"
            >
              <Flex
                flexDir={"column"}
                alignItems="center"
                color={theme.error}
                fontWeight={"medium"}
              >
                <Text fontSize="sm">
                  (*) Campo de preenchimento obrigatório
                </Text>
                <Flex alignItems="center">
                  <Icon as={AiOutlineInfoCircle} color={theme.error} mr={1} />
                  <Text fontSize="sm">
                    O campo apresenta formato ou dado inválido
                  </Text>
                </Flex>
              </Flex>

              <HStack spacing={3}>
                <Button error title="CANCELAR" onClick={onBack} />

                <Button
                  title={loading ? <Spinner /> : "CRIAR OPORTUNIDADE"}
                  onClick={formik.handleSubmit}
                  disabled={require || loading}
                />
              </HStack>
            </Flex>
          </>
        )}
      </Box>
    </>
  );
};

export default React.memo(CreateMyOportunityComponent);
